const appConfig = {
  apiPrefix: process.env.REACT_APP_BACKEND_URL,
  authenticatedEntryPath: "/app/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  enableMock: false,
};

export default appConfig;
